<template>
  <ul :class="$style.root">
    <template
      v-for="(entry, index) in data?.data"
      :key="entry?.id"
    >
      <li
        :class="$style.groupKey"
        v-if="getDatePostedYear(data?.data[index - 1]) && getDatePostedYear(data?.data[index - 1]) !== getDatePostedYear(entry)"
      >
        <layout-group-key-component>
          {{ getDatePostedYear(entry) }}
        </layout-group-key-component>
      </li>

      <li>
        <shared-news-thumbnail-component
          :data="entry"
        />
      </li>
    </template>

    <li
      v-if="!data?.data?.length"
      :class="$style.noResults"
    >
      {{ $t('shared.noResultsForType', { type: $t('labels.news')?.toLowerCase() }) }}
    </li>
  </ul>
</template>

<script lang="ts" setup>
const route = useRoute()

const props = defineProps({
  editionId: {
    type: [String, Number],
    required: false
  }
})

// 1
const page = ref(1)

const filterId = computed(() => {
  return props?.editionId || route.query.biennialEntryId
})

watch(filterId, () => {
  page.value = 1
})

const { data, error, execute, status } = await useAsyncData(() => {
  const appVariant = getAppVariant()
  const query = getAppVariant() === 'main' ? queryNewsEntriesThumbnailMain : queryNewsEntriesThumbnailInterim
  return $fetch('/api/strapi-rest', { query: { path: query(getPageQuery({page: page.value, filterId: filterId.value})) } })
}, { watch: [page, filterId], immediate: true })

const canLoadMore = computed(() => {
  return data.value?.meta?.pagination?.page < data.value?.meta?.pagination?.pageCount
})

watch(data, (newValue, oldValue) => {
  if (oldValue && newValue && newValue.meta?.pagination?.page === (oldValue.meta?.pagination?.page + 1) ) {
    data.value.data = oldValue.data.concat(newValue.data)
    if (canLoadMore.value) {
      page.value++
    }
  } else if ( newValue ) {
    data.value = newValue
  }
})

setTimeout(() => {
  if (canLoadMore.value) {
    page.value++
  }
}, 10)

// 2
const getDatePostedYear = (entry) => {
  if (!entry?.datePosted) return null
  return dayJs(entry?.datePosted)?.format('YYYY')
}
</script>

<style module lang="scss">
.root {
  composes: reset-list container-flex container-large from global;
}

.groupKey {
  width: 100%;
  text-align: center;

  margin-top: var(--unit--vertical);
  margin-bottom: var(--unit--vertical);
}

.noResults {
  composes: container caption font-size-small from global;

  padding: var(--padding--element);

  backdrop-filter: var(--backdrop-filter--dark);
  border-radius: var(--border-radius--default);

  margin-bottom: calc(var(--font-small--line-height) + (var(--font-small--line-height) - var(--unit--vertical)));
}
</style>
